import { MultiSelect, MultiSelectChangeParams } from 'primereact/multiselect';
import styles from './CompetitorSelect.module.scss';
import { DropdownOption } from '../../../../models/common/DropdownOption';
import { IManualInputFiltersCompetitor } from '../../models/manualInputFilters';

const panelFooterTemplate = (confirmCompetitors: any) => {
	return (
		<button
			className={`${styles.confirmCompetitorsButton} btn secondary`}
			onClick={confirmCompetitors}
		>
			Confirm
		</button>
	);
};

export interface ICompetitorSelectProps {
	competitorSelectOptions: DropdownOption[];
	selectedCompetitors: IManualInputFiltersCompetitor[];
	setSelectedCompetitors: (competitors: number[]) => void;
	confirmCompetitors: () => void;
}

const CompetitorSelect = ({
	competitorSelectOptions,
	selectedCompetitors,
	setSelectedCompetitors,
	confirmCompetitors
}: ICompetitorSelectProps): JSX.Element => {
	const selectedCompetitorIds = selectedCompetitors.map(
		(c) => c.competitorId
	);

	return (
		<div>
			<MultiSelect
				appendTo='self'
				placeholder='Select competitors'
				className={styles.competitorSelect}
				value={selectedCompetitorIds}
				options={competitorSelectOptions}
				onChange={(e: MultiSelectChangeParams) => {
					setSelectedCompetitors(e.value);
				}}
				panelFooterTemplate={panelFooterTemplate(confirmCompetitors)}
				filter
			/>
		</div>
	);
};

export default CompetitorSelect;
